

<ng-container *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $">

<div
    *ngIf="$.row && !$.adata.originalKey; else showOriginal"
    class="flex align-items-center cursor-pointer"
    (click)="toggleOverlay($event)"
    (mouseenter)="op.show($event)" (mouseleave)="op.hide()"
  >
    <p-avatar
      *ngIf="$.row && !isEmptyAndNull($.row[$.adata.fetch_key+'_stf_ff_picture']); else noContactPic"
      [image]="$.row[$.adata.fetch_key+'_stf_ff_picture']"
      styleClass="mr-3 overflow-hidden border-round"
    ></p-avatar>

    <ng-template #noContactPic>
      <p-avatar styleClass="text-sm mr-3" label="{{ $.row[$.adata.fetch_key+'_stf_name'] | titlecase | shortName }}" ></p-avatar>
    </ng-template>

    <span class="text-primary text-sm font-bold">{{ $.row[$.adata.fetch_key+'_stf_name'] }}</span>
  </div>
  <ng-template #showOriginal>

  <div
    *ngIf="$.row && $.adata.originalKey; else dash"
    class="flex align-items-center cursor-pointer"
    (click)="toggleOverlay($event)"
    (mouseenter)="op2.show($event)" (mouseleave)="op2.hide()"
  >
    <p-avatar
      *ngIf="$.row && !isEmptyAndNull($.row['stf_ff_picture']); else noContactPic"
      [image]="$.row['stf_ff_picture']"
      styleClass="mr-3 overflow-hidden border-round"
    ></p-avatar>

    <ng-template #noContactPic>
      <p-avatar
        styleClass="text-sm mr-3"
        label="{{ $.row['stf_name'] | titlecase | shortName }}"
      ></p-avatar>
    </ng-template>

    <span class="text-primary text-sm font-bold">{{ $.row['stf_name'] }}</span>
  </div>
  </ng-template>
  <ng-template #dash>-</ng-template>

<p-popover  #op styleClass="overflow-hidden text-sm">
  <ng-template #content>

    <!-- Dropdown Content -->
    <div class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2">
      <div class="w-10rem line-height-1">
        <div class="text-sm font-medium text-800">{{ $.row[$.adata.fetch_key+'_stf_name'] | titlecase }}</div>
        <div class="text-xs text-600 mt-1">{{ $.row[$.adata.fetch_key+'_stf_id'] }}</div>
      </div>
    </div>
    <!-- Dropdown Content -->

    <!-- Dropdown Footer -->
    <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
      <div class="flex align-items-center mb-2">
        <i class="fa fa-phone mr-2 text-500"></i>
        <span *ngIf="!isEmptyAndNull($.row[$.adata.fetch_key+'_stf_mobile_country_code']) ;else not_specified ">{{ $.row[$.adata.fetch_key+'_stf_mobile_country_code'] }} {{ $.row[$.adata.fetch_key+'_stf_mobileno']}} </span>
        <ng-template #not_specified>Not specified</ng-template>
      </div>
      <div class="flex align-items-center mb-1">
        <i class=" fa fa-envelope font-light mr-2 text-500"></i>
        <span class="break-word">{{ $.row[$.adata.fetch_key+'_stf_emailid'] }}</span>
      </div>
    </div>
    <!-- Dropdown Footer -->

  </ng-template>
</p-popover>

<p-popover  #op2 styleClass="overflow-hidden text-sm">
  <ng-template #content>

    <!-- Dropdown Content -->
    <div class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2">
      <div class="w-10rem line-height-1">
        <div class="text-sm font-medium text-800">{{ $.row['stf_name'] | titlecase }}</div>
        <div class="text-xs text-600 mt-1">{{ $.row['stf_id'] }}</div>
      </div>
    </div>
    <!-- Dropdown Content -->

    <!-- Dropdown Footer -->
    <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
      <div class="flex align-items-center mb-2">
        <i class="fa fa-phone mr-2 text-500"></i>
        <span *ngIf="!isEmptyAndNull($.row['stf_mobile_country_code']) ;else not_specified ">{{ $.row['_stf_mobile_country_code'] }} {{ $.row['stf_mobileno']}} </span>
        <ng-template #not_specified>Not specified</ng-template>
      </div>
      <div class="flex align-items-center mb-1">
        <i class=" fa fa-envelope font-light mr-2 text-500"></i>
        <span class="break-word">{{ $.row['stf_emailid'] }}</span>
      </div>
    </div>
    <!-- Dropdown Footer -->

  </ng-template>
</p-popover>
</ng-container>
